import api from "./api";

// 生成记录文件删除
export const deleteMakeSourceRecord = async (ids: number[]) => {
  const res = await api.post<unknown>(`/ai_make_source_record/delete`, {
    ids
  });
  return res;
};
